<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th class="name-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let action of actions | async"
        (click)="select(action)"
        [class.selected]="action === selectedAction"
      >
        <td>
          <span
            [style.background-color]="'#fff333'"
            mat-icon-button
            class="reduced"
          >
            <mat-icon [style.color]="'#00000'">
              {{ getIconForAction(action) }}</mat-icon
            > </span
          >{{ action.name | translate }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
